import { Box } from '../../Box';
import { Typography } from '../../Typography';
import { Icon } from '../../Icon';

interface TagProps {
  label: string;
  disabled: boolean;
  onDelete: () => void;
}

export const Tag = ({ label, disabled, onDelete }: TagProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap="8"
      px="8"
      height={32}
      border={1}
      bgcolor="bg.greyscale.primary"
      borderColor="stroke.primary"
      radius="m"
    >
      <Typography
        variant="body3"
        color={disabled ? 'text.light.tertirary' : 'text.light.primary'}
      >
        {label}
      </Typography>
      {!disabled && (
        <Box
          width={20}
          height={20}
          cursor={disabled ? 'default' : 'pointer'}
          testId={`tag-delete-${label}`}
          onClick={onDelete}
        >
          <Icon name="cancel_outline" size="20" color="stroke.secondary" />
        </Box>
      )}
    </Box>
  );
};
